export default {
  title: 'Oblíbené',

  // Czech plural forms: 1 / 2-4 / 5+
  savedCount: '{count} uložená hra | {count} uložené hry | {count} uložených her',
  clearAll: 'Vymazat vše',
  cleared: 'Z oblíbených odebrána {count} hra | Z oblíbených odebrány {count} hry | Z oblíbených odebráno {count} her',

  sort: {
    aria: 'Řadit podle',
    recent: 'Nedávno přidané',
    oldest: 'Od nejstarších',
    name: 'Název A–Z',
    priceAsc: 'Cena ↑',
    priceDesc: 'Cena ↓',
  },

  empty: {
    title: 'Zatím žádné oblíbené',
    body: 'Klikněte na srdíčko u libovolné hry, uložte si ji na později a sledujte, kdy zlevní.',
    cta: 'Procházet katalog',
  },
};
